// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { Modal, Table, Button, Container, Form } from 'react-bootstrap';
// import axios from 'axios';

// const Help = () => {
  // const { uid } = useParams();
  // const [events, setEvents] = useState([]);

  // const [showModal, setShowModal] = useState(false);
  // const [currentStatus, setCurrentStatus] = useState('');
  // const [currentEventId, setCurrentEventId] = useState(null);
  // const [feedbackMessage, setFeedbackMessage] = useState('');

  // const handleSubmitStatusChange = () => {
  //   if (feedbackMessage.trim() === '') {
  //     alert("Feedback message cannot be empty.");
  //     return;
  //   }

  //   handleStatusChange(currentEventId, currentStatus, feedbackMessage.trim());
  //   setShowModal(false);
  //   setFeedbackMessage('');
  // };

  // useEffect(() => {
  //   fetchEvents();
  // }, []);

  // const fetchEvents = async () => {
  //   try {
  //     const res = await axios.get('https://vms-pjum.onrender.com/api/help/all');
  //     
  //     setEvents(res.data);
  //   } catch (error) {
  //     console.error('Failed to fetch help events:', error);
  //   }
  // };

  // const handleStatusChange = async (id, status, message) => {
  //   try {
  //     
  //     await axios.put(`https://vms-pjum.onrender.com/api/help/status/${id}`, { status, message });
  //     fetchEvents();
  //   } catch (error) {
  //     console.error('Failed to update status:', error);
  //   }
  // };

//   return (
//     <Container className="mt-5">
//       <h2>Admin Dashboard</h2>
//       <p>Logged in as UID: {uid}</p>
//       <Table striped bordered responsive>
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Title</th>
//             <th>Description</th>
//             <th>Start Date</th>
//             <th>End Date</th>
//             <th>Location</th>
//             <th>Volunteers Needed</th>
//             <th>Event Status</th>
//             <th>Help Status</th>
//             <th>FeedBack</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {events.map(ev => (
//             <tr key={ev.userId}>
//               <td>{ev.userId?.name || '-'}</td>
//               <td>{ev.title}</td>
//               <td>{ev.description}</td>
//               <td>{ev.startDate}</td>
//               <td>{ev.endDate}</td>
//               <td>{ev.location}</td>
//               <td>{ev.volunteersNeeded}</td>
//               <td>{ev.status}</td>
//               <td>{ev.helpStatus}</td>
//               <td>{ev.helpStatus === 'pending' ? (
//                   <span className="text-muted fst-italic">Add feedback by approving or disapproving</span>
//                 ) : (
//                   <span>{ev.helpFeedback || '—'}</span>
//                 )}</td>
//               <td>
//                 {ev.helpStatus === "approved" ? (
//                   <span className="text-success fw-bold">Approved</span>
//                 ) : ev.helpStatus === "disapproved" ? (
//                   <span className="text-danger fw-bold">Disapproved</span>
//                 ) :(
//                   <>
//                     <Button
//                       variant="success"
//                       size="sm"
//                       onClick={() => {
//                         setCurrentStatus("approved");
//                         setCurrentEventId(ev.id);
//                         setShowModal(true);
//                       }}
//                     >
//                       Approve
//                     </Button>{' '}
//                     <Button
//                       variant="danger"
//                       size="sm"
                      // onClick={() => {
                      //   setCurrentStatus("disapproved");
                      //   setCurrentEventId(ev.id);
                      //   setShowModal(true);
                      // }}
//                     >
//                       Disapprove
//                     </Button>
//                   </>
//                 )}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>

      // <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      //   <Modal.Header closeButton>
      //     <Modal.Title>Provide Feedback</Modal.Title>
      //   </Modal.Header>
      //   <Modal.Body>
      //     <Form.Group>
      //       <Form.Label>Feedback Message</Form.Label>
      //       <Form.Control
      //         as="textarea"
      //         rows={3}
      //         value={feedbackMessage}
      //         onChange={(e) => setFeedbackMessage(e.target.value)}
      //         placeholder="Enter your feedback..."
      //       />
      //     </Form.Group>
      //   </Modal.Body>
      //   <Modal.Footer>
      //     <Button variant="secondary" onClick={() => setShowModal(false)}>
      //       Cancel
      //     </Button>
      //     <Button variant="primary" onClick={handleSubmitStatusChange}>
      //       Submit
      //     </Button>
      //   </Modal.Footer>
      // </Modal>

//     </Container>
//   );
// };

// export default Help;


import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Button, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import { BsCalendarEvent, BsCheck2Circle, BsXCircle } from 'react-icons/bs';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import { Download } from 'lucide-react';
import { generateHelpRequestsPDF } from '../../../../utils/pdfUtils';
import { API_ENDPOINTS } from '../../../../config/api';


const AdminHelp = () => {
  const { uid } = useParams();
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentStatus, setCurrentStatus] = useState('');
  const [currentEventId, setCurrentEventId] = useState(null);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [statusFilter, setStatusFilter] = useState('all'); // New state for status filter
  const [formData, setFormData] = useState({
    title: '', description: '', startDate: '', endDate: '',
    startTime: '', endTime: '', location: '', category: 'Environmental',
    volunteersNeeded: 0, extraVolunteersForHelp: false
  });
  const [formVisible, setFormVisible] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [eventid, setEventid] = useState(null);

  const handleSubmitStatusChange = () => {
    if (feedbackMessage.trim() === '') {
      alert("Feedback message cannot be empty.");
      return;
    }

    handleStatusChange(currentEventId, currentStatus, feedbackMessage.trim());
    setShowModal(false);
    setFeedbackMessage('');
  };

  useEffect(() => {
    fetchEvents();
  }, [statusFilter]); // Refetch events when statusFilter changes

  const fetchEvents = async () => {
    try {
      const res = await axios.get(`${API_ENDPOINTS.HELP.BASE}/all`);
      
      setEvents(res.data);
    } catch (error) {
      console.error('Failed to fetch help events:', error);
    }
  };

  const handleStatusChange = async (id, status, message) => {
    try {
      
      await axios.put(`${API_ENDPOINTS.HELP.BASE}/status/${id}`, { status, message });
      fetchEvents();
    } catch (error) {
      console.error('Failed to update status:', error);
    }
  };

  const validateForm = () => {
    const today = new Date().setHours(0, 0, 0, 0);
    const start = new Date(formData.startDate).setHours(0, 0, 0, 0);
    const end = new Date(formData.endDate).setHours(0, 0, 0, 0);
  
    if (start < today) {
      alert('Start date cannot be in the past.');
      return false;
    }
  
    if (end < start) {
      alert('End date cannot be before start date.');
      return false;
    }

    if(!formData.startTime || !formData.endTime) {
      alert("Please enter Accurate Time");
      return false;
    }
  
    if (formData.startDate === formData.endDate) {
      const [startHour, startMin] = formData.startTime.split(':').map(Number);
      const [endHour, endMin] = formData.endTime.split(':').map(Number);
      const startMinutes = startHour * 60 + startMin;
      const endMinutes = endHour * 60 + endMin;
  
      if (endMinutes <= startMinutes) {
        alert('End time must be after start time on the same day.');
        return false;
      }
    }
  
    return true;
  };

  const handleCreateOrUpdate = async () => {
    if (!validateForm()) return;
  
    try {
      if(isUpdating){
        await axios.put(API_ENDPOINTS.HELP.UPDATE(eventid), {
          ...formData,
          userIdForHelp: uid,
        });
      } else {
        await axios.post(API_ENDPOINTS.HELP.CREATE, {
          ...formData,
          userIdForHelp: uid,
        });
      }
      setFormVisible(false);
      setFormData({
        title: '', description: '', startDate: '', endDate: '',
        startTime: '', endTime: '', location: '', category: 'Environmental',
        volunteersNeeded: 0, extraVolunteersForHelp: false
      });
      fetchEvents();
    } catch (err) {
      console.error("Error creating/updating event:", err);
      if (err.response?.status === 403) {
        alert(err.response.data.message || "You don't have permission to perform this action.");
      } else {
        alert("Error creating/updating event. Please try again.");
      }
    }
  };
  
  const handleCancelEvent = async (eventId) => {
    if (window.confirm('Are you sure you want to delete this event?')) {
      try {
        // Use the help-specific cancel endpoint since these are help events
        await axios.put(API_ENDPOINTS.HELP.CANCEL(eventId));
        fetchEvents();
      } catch (err) {
        console.error('Error Canceling event:', err);
        if (err.response?.status === 403) {
          alert(err.response.data.message || "You don't have permission to perform this action.");
        } else {
          alert('Failed to cancel event');
        }
      }
    }
  };

  const handleDownloadPDF = () => {
    if (events.length === 0) {
      alert('No help requests available to download');
      return;
    }
    
    // Filter events based on current status filter if any
    const filteredEvents = statusFilter === 'all' ? events : events.filter(event => event.helpStatus === statusFilter);
    const statusLabel = statusFilter === 'all' ? 'All Help Requests' : `${statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1)} Help Requests`;
    
    generateHelpRequestsPDF(filteredEvents, statusLabel);
  };

  return (
    <div className='main-content'>
    <Container className="px-4 py-3">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-0" style={{ color: '#a70a4a', fontWeight: '600' }}>
            <BsCalendarEvent style={{ marginRight: '10px' }} />
            Help Requests
          </h2>
          <p style={{ color: '#7f8c9b', fontSize: '0.85rem', marginBottom: 0 }}>Review and manage volunteer-created help requests</p>
        </div>
        <button
          onClick={handleDownloadPDF}
          className="db1-export-btn"
          style={{ background: '#16a34a', color: 'white' }}
          title="Download Help Requests as PDF"
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>

      <div className="db1-glass-card" style={{ padding: 0, overflow: 'hidden' }}>
        <div className="table-responsive">
          <table className="table mb-0 align-middle" style={{ fontSize: '0.88rem' }}>
            <thead>
              <tr>
                <th style={{ color: '#7f8c9b', fontWeight: 600, fontSize: '0.82rem', padding: '14px 16px', borderBottom: '2px solid rgba(172,46,98,0.1)' }}>Name</th>
                <th style={{ color: '#7f8c9b', fontWeight: 600, fontSize: '0.82rem', padding: '14px 16px', borderBottom: '2px solid rgba(172,46,98,0.1)' }}>Email</th>
                <th style={{ color: '#7f8c9b', fontWeight: 600, fontSize: '0.82rem', padding: '14px 16px', borderBottom: '2px solid rgba(172,46,98,0.1)' }}>Phone</th>
                <th style={{ color: '#7f8c9b', fontWeight: 600, fontSize: '0.82rem', padding: '14px 16px', borderBottom: '2px solid rgba(172,46,98,0.1)' }}>Title</th>
                <th style={{ color: '#7f8c9b', fontWeight: 600, fontSize: '0.82rem', padding: '14px 16px', borderBottom: '2px solid rgba(172,46,98,0.1)' }}>Start Date</th>
                <th style={{ color: '#7f8c9b', fontWeight: 600, fontSize: '0.82rem', padding: '14px 16px', borderBottom: '2px solid rgba(172,46,98,0.1)' }}>Status</th>
                <th style={{ color: '#7f8c9b', fontWeight: 600, fontSize: '0.82rem', padding: '14px 16px', borderBottom: '2px solid rgba(172,46,98,0.1)' }}>Feedback</th>
                <th style={{ color: '#7f8c9b', fontWeight: 600, fontSize: '0.82rem', padding: '14px 16px', borderBottom: '2px solid rgba(172,46,98,0.1)', textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.map((ev) => (
                <tr key={ev.id}>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0,0,0,0.04)', color: '#2c3e50' }}>{ev.userId?.name || '-'}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0,0,0,0.04)', color: '#2c3e50' }}>{ev.userId?.email || '-'}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0,0,0,0.04)', color: '#2c3e50' }}>{ev.userId?.mobileNo || '-'}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0,0,0,0.04)', color: '#2c3e50' }}>{ev.title}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0,0,0,0.04)', color: '#7f8c9b' }}>{ev.startDate}</td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                    <span className={`db1-badge ${ev.helpStatus === 'approved' ? 'active' : ev.helpStatus === 'disapproved' ? 'inactive' : ''}`}>
                      {ev.helpStatus.charAt(0).toUpperCase() + ev.helpStatus.slice(1)}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0,0,0,0.04)', color: '#7f8c9b', fontSize: '0.85rem' }}>
                    {ev.helpStatus === 'pending' ? (
                      <span style={{ fontStyle: 'italic', opacity: 0.6 }}>Add feedback by approving or disapproving</span>
                    ) : (
                      <span>{ev.helpFeedback || '—'}</span>
                    )}
                  </td>
                  <td style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
                    <div className="d-flex gap-2 justify-content-center">
                      <button className="db1-nav-btn" onClick={() => setSelectedEvent(ev)} title="View details">
                        <FaEye />
                      </button>
                      <button
                        className="db1-export-btn"
                        style={{ background: ev.helpStatus === 'approved' ? '#16a34a' : 'rgba(22,163,74,0.1)', color: ev.helpStatus === 'approved' ? 'white' : '#16a34a', padding: '6px 10px', fontSize: '0.82rem' }}
                        onClick={() => {
                          setCurrentStatus("approved");
                          setCurrentEventId(ev.id);
                          setShowModal(true);
                        }}
                      >
                        <BsCheck2Circle />
                      </button>
                      <button
                        className="db1-export-btn"
                        style={{ background: ev.helpStatus === 'disapproved' ? '#dc2626' : 'rgba(220,38,38,0.1)', color: ev.helpStatus === 'disapproved' ? 'white' : '#dc2626', padding: '6px 10px', fontSize: '0.82rem' }}
                        onClick={() => {
                          setCurrentStatus("disapproved");
                          setCurrentEventId(ev.id);
                          setShowModal(true);
                        }}
                      >
                        <BsXCircle />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {selectedEvent && (
        <Modal show onHide={() => setSelectedEvent(null)} centered>
          <div className="db1-modal-header">
            <h5 className="mb-0" style={{ color: '#2c3e50' }}>Event Details</h5>
            <button onClick={() => setSelectedEvent(null)} className="btn-close" style={{ color: '#a70a4a' }}></button>
          </div>
          <div className="db1-modal-content">
            <p style={{ color: '#2c3e50' }}><strong>Title:</strong> {selectedEvent.title}</p>
            <p style={{ color: '#2c3e50' }}><strong>Start Date:</strong> {selectedEvent.startDate}</p>
            <p style={{ color: '#2c3e50' }}><strong>End Date:</strong> {selectedEvent.endDate || '-'}</p>
            <p style={{ color: '#2c3e50' }}><strong>Start Time:</strong> {selectedEvent.startTime}</p>
            <p style={{ color: '#2c3e50' }}><strong>End Time:</strong> {selectedEvent.endTime}</p>
            <p style={{ color: '#2c3e50' }}><strong>Location:</strong> {selectedEvent.location}</p>
            <p style={{ color: '#2c3e50' }}><strong>Volunteers Needed:</strong> {selectedEvent.volunteersNeeded}</p>
            <p style={{ color: '#2c3e50' }}><strong>Event Status:</strong> {selectedEvent.status}</p>
            <p style={{ color: '#2c3e50' }}><strong>Help Status:</strong> {selectedEvent.helpStatus}</p>
            <p style={{ color: '#2c3e50' }}><strong>FeedBack:</strong> {selectedEvent.helpStatus === 'pending' ? (
                  <span style={{ fontStyle: 'italic', opacity: 0.6 }}>Add feedback by approving or disapproving</span>
                ) : (
                  <span>{selectedEvent.helpFeedback || '—'}</span>
                )}</p>
          </div>
          <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid rgba(0,0,0,0.04)', display: 'flex', justifyContent: 'flex-end' }}>
            <button onClick={() => setSelectedEvent(null)} className="db1-delete-btn">Close</button>
          </div>
        </Modal>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <div className="db1-modal-header">
          <h5 className="mb-0" style={{ color: '#2c3e50' }}>Provide Feedback</h5>
          <button onClick={() => setShowModal(false)} className="btn-close" style={{ color: '#a70a4a' }}></button>
        </div>
        <div className="db1-modal-content">
          <Form.Group>
            <Form.Label style={{ color: '#2c3e50', fontWeight: 600 }}>Feedback Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={feedbackMessage}
              onChange={(e) => setFeedbackMessage(e.target.value)}
              placeholder="Enter your feedback..."
            />
          </Form.Group>
        </div>
        <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid rgba(0,0,0,0.04)', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <button className='db1-delete-btn' onClick={() => setShowModal(false)}>Cancel</button>
          <button className='db1-export-btn' style={{ background: '#ac2e62', color: 'white' }} onClick={handleSubmitStatusChange}>Submit</button>
        </div>
      </Modal>

    </Container>
    </div>
  );
};

export default AdminHelp;